import React from 'react'
export const CheckedIcon: React.FC = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 18 18'
      className='checked-icon'
      width='14px'
      height='100%'
    >
      <path
        d='M9 18A9 9 0 119 0a9 9 0 010 18zm-1.394-6.883L5.056 7.18 3.377 8.266l4.21 6.503 6.81-10.286-1.667-1.104-5.124 7.738z'
        fill='currentColor'
        fillRule='evenodd'
      />
    </svg>
  )
}
